var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-mb-4 md:tw-mb-5 text-center"},[_c('img',{staticClass:"img-content",attrs:{"loading":"lazy","src":_setup.props.content,"alt":""}}),_c(_setup.CompShareSocialNetworks,_vm._b({attrs:{"url":_setup.props.content,"title":"Imagen"}},'CompShareSocialNetworks',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }